import { _actions } from './action-types'
import { _mutations } from './mutation-types'
import RulesService from '@/api/rules'

export const actions = {
  async [_actions.INIT_RULES_MODULE] ({commit, dispatch}) {
    commit('activeModule', 'Rules', { root: true })
    return await Promise.all([
      dispatch(_actions.LOAD_PROJECTS),
      dispatch(_actions.LOAD_PACKAGES)
    ])
  },
  async [_actions.LOAD_PROJECTS] ({commit, state}) {
    if (!state.projects) {
      commit(_mutations.SET_PROJECTS, await RulesService.getProjects())
    }
  },
  async [_actions.RELOAD_PROJECTS] ({commit}) {
    commit(_mutations.RESET_PROJECTS)
    commit(_mutations.SET_PROJECTS, await RulesService.getProjects())
  },
  async [_actions.LOAD_PACKAGES] ({commit, state}) {
    if (!state.packages) {
      commit(_mutations.SET_PACKAGES, await RulesService.getPackages())
    }
  },
  async [_actions.RELOAD_PACKAGES] ({commit}) {
    commit(_mutations.RESET_PACKAGES)
    commit(_mutations.SET_PACKAGES, await RulesService.getPackages())
  },
  async [_actions.LOAD_CATALOG] ({commit, state}) {
    if (!state.catalog) {
      commit(_mutations.SET_CATALOG, await RulesService.getFunctionsCatalog())
    }
  },
  async [_actions.RELOAD_CATALOG] ({commit}) {
    commit(_mutations.RESET_CATALOG)
    commit(_mutations.SET_CATALOG, await RulesService.getFunctionsCatalog())
  },
  async [_actions.SET_ACTIVE_PROJECT] ({commit, state}, { projectId, force }) {
    if (force || state.activeProject && state.activeProject.id !== projectId) {
      const [project, versions] = await Promise.all([
        RulesService.getProject(projectId),
        RulesService.getVersions(projectId)
      ])
      actions[_actions.LOAD_CATALOG]({commit, state})
      let mainPackage = await RulesService.getPackage(project.mainPackage)
      project.mainPackageId = mainPackage.packageId
      project.versions = versions
      commit(_mutations.UPDATE_ACTIVE_PROJECT, project)
      actions[_actions.GET_UNCOMMITTED_COMPONENTS]({commit, state})
    }
  },
  async [_actions.REFRESH_ACTIVE_PROJECT] ({commit, state}) {
    return await actions[_actions.SET_ACTIVE_PROJECT]({commit, state}, {
      projectId: state.activeProject.id,
      force: true
    })
  },
  async [_actions.GET_UNCOMMITTED_COMPONENTS] ({commit, state}) {
    commit(_mutations.START_LOADING_UNCOMMITTED_COMPONENTS)
    try {
      const uncommittedComponents = await RulesService.getUncommittedComponents(state.activeProject.projectId)
      commit(_mutations.SET_UNCOMMITTED_COMPONENTS, uncommittedComponents)
    } catch (error) {
      commit(_mutations.SET_UNCOMMITTED_COMPONENTS_ERROR, error)
    }
    commit(_mutations.STOP_LOADING_UNCOMMITTED_COMPONENTS)
    commit(_mutations.SET_UNCOMMITTED_COMPONENTS_LOADED)
  }
}
